export default __webpack_public_path__ + "static/media/paul_gowder.ab922af1.png";